module.exports = __webpack_public_path__ + "static/media/call3.b8ba31ee.png";